(function($){
	/**
	*	OmotesandoHills Common JS
	*	@namespace OH
	*	@type {PropertiesHash}
	*/
	window.OH = {
		/**
		*	OHに固有な値を保持する受け皿としての連想配列です。
		* 定数的な値 や staticな設定項目を前提とします。
		*/
		settings : new Object(),

		/**
		*	window.onresize時に実行される処理を一括管理するオブジェクト(擬似的なinstance)です。
		*	通常は window.onresize(or window.addEventListener("resize", somefunc, bool))はresizeされる度にfireされますが、
		*	これは、resize後に１度だけ実行されれば十分な処理については不都合なことです。
		*	そのような処理を onResizeTasks.append で登録しておくことで、resize後に１度だけ実行されます。
		*	@name onResizeTasks
		*	@memberof OH
		*	@instance
		*	@requires jQuery(as $)
		*	@example
		*	// 登録用の記述
		*	var taskKey = "TASK01"; // any keyword
		*	var todoAfterResize = function(){ console.log("resized!"); };
		*	OH.onResizeTasks.append(taskKey, todoAfterResize);
		*	@example
		*	// 登録時にそのまま実行したい場合
		*	OH.onResizeTasks.append(taskKey, todoAfterResize, true);
		*	@example
		*	// 登録したものを解除したい場合
		*	OH.onResizeTasks.remove(taskKey);
		*/
		onResizeTasks : (function(){
			var that = new Object();
			var tasks = new Object();
			var duration = 300;
			var timer;
			var exec = function(){
				timer = null;
				for(var key in tasks){
					if(typeof tasks[key] === "function"){
						tasks[key]();
					}
				}
			};

			/**
			*	resize後に実行する処理を登録します
			*	@name append
			*	@memberof OH.onResizeTasks
			*	@function
			*	@access public
			*	@callback taskFunction
			*	@param {string} key 登録用のキーワード。他の登録済み処理と被らない名前を設定
			*	@param {taskFunction} taskFunction 登録する処理関数
			*	@param {?boolean} execOnInit 登録時にそのまま実行したい場合にtrueを指定(省略時はfalse)
			*/
			that.append = function(key, taskFunction, execOnInit){
				tasks[key] = taskFunction;
				if(!!execOnInit){
					taskFunction();
				}
			};

			/**
			*	登録済みの処理を削除します
			*	@name remove
			*	@memberof OH.onResizeTasks
			*	@function
			*	@access public
			*	@param {string} key 登録時に設定したキーワード
			*/
			that.remove = function(key){
				if(!!tasks[key]){
					delete tasks[key];
				}
			};

			$(window).on("resize", function(){
				if(!!timer){
					window.clearTimeout(timer);
				}
				timer = window.setTimeout(exec, duration);
			});
			return that;
		})(),

		/**
		*	JavaScriptにて動的に出力するCSSを管理するオブジェクト(擬似的なinstance)です。
		*	ここで扱うCSSは HTMLのstyle要素に相当します。
		*	CSSを動的に出力することは、次のようなケースに有用です。
		*	<ul>
		*		<li>JSで閉じたコンポーネント に専用のスタイルを使用したい場合</li>
		*		<li>transitionなど、CSSの値にvender-prefixが入る可能性がある場合</li>
		*	</ul>
		*	dynamicCSSから取得したスタイルシートには、addRuleメソッドでruleを記述することができます。
		*	@name dynamicCSS
		*	@memberof OH
		*	@instance
		*	@example
		*	// 取得用の記述
		*	var sheetID = "CSS1"; // any keyword
		*	var sheet = OH.dynamicCSS.register(sheetID);
		*	sheet.addRule("BODY{color:red;}");
		*	@example
		*	// CSSへの操作を１度だけに限定したい場合
		*	var sheet = OH.dynamicCSS.register(sheetID, true); // 登録済みの場合は false が返される
		*	if(!!sheet){
		*		sheet.addRule("BODY{color:red;}");
		*	}
		*	@example
		*	// 登録済みであるか確認したい場合
		*	if(OH.dynamicCSS.hasRegistered()){
		*		// console.log("ID:" + sheetID + "は登録済み");
		*	}
		*/
		dynamicCSS : (function(){
			var that = {};
			var sheets = {};

			/**
			*	登録済みのCSSであるか確認します
			*	@name hasRegistered
			*	@memberof OH.dynamicCSS
			*	@function
			*	@access public
			*	@param {string} key 登録時に設定したキーワード
			*/
			that.hasRegistered = function(key){
				return !!sheets[key];
			};

			/**
			*	CSSを動的に登録し、その生成したCSSを受け取ります
			*	@name register
			*	@memberof OH.dynamicCSS
			*	@function
			*	@access public
			*	@param {string} key 登録時に設定したキーワード
			*	@param {?boolean} once trueとした場合、同じkeyでの登録が２度目以降である場合にfalseを返します
			*/
			that.register = function(key, once){
				if(!!sheets[key]){
					return !!once ? false : sheets[key];
				}
				var styleElement = document.createElement("style");
				styleElement.appendChild(document.createTextNode(""));
				document.head.appendChild(styleElement);
				sheets[key] = {
					sheet : styleElement.sheet,
					addRule : function(statement){
						styleElement.sheet.insertRule(statement, styleElement.sheet.cssRules.length);
					}
				};
				return sheets[key];
			}

			return that;
		})(),

		/**
		*	CSSの過渡期にあるproperty名に対し、必要に応じてvender-prefixをつけて返します。
		*	@name transitionalStyleProperty
		*	@memberof OH
		*	@function
		*	@requires jQuery(as $)
		*	@param {string} prop 調べたいCSS property名
		*	@param {?string} noSupport vender-prefix無しでもサポートされていない場合に返す値を指定します。省略時のreturn値は ""
		*	@returns {string} ブラウザでサポートされている形式の CSS property名
		*	@example
		*	// 一部のブラウザでvender-prefixが必要な場合の処理例
		*	$('<div>').css(OH.transitionalStyleProperty("transform"), "rotate(90deg)");
		*	// サポートされていないブラウザにはダミーのproperty名をセットしたい場合
		*	$('<div>').css(OH.transitionalStyleProperty("transform", "_"), "rotate(90deg)");
		*	@example
		*	// サポートされていればスタイルを当てたい場合 の例
		*	var writingModeProp = OH.transitionalStyleProperty("writing-mode");
		*	if(!!writingModeProp){
		*		$('<div>').css(writingModeProp, "vertical-rl");
		*	}
		*/
		transitionalStyleProperty : function(prop, noSupport){
			var candidates = ["ms", "webkit", "moz", "o", ""];
			var toChainCase = function(original, prefix){
				if(!prefix){
					return original;
				}
				return "-" + prefix + "-" + original;
			};
			var toCamelCase = function(original, prefix){
				return toChainCase(original, prefix).replace(/\-./g, function(s){ return s.charAt(1).toUpperCase(); });
			};
			var toStyleProp = function(fullCamel){
					return fullCamel.charAt(0).toLowerCase() + (fullCamel.length > 1 ? fullCamel.slice(1) : "");
			};
			var disposable = document.createElement("div");
			$(disposable).css({ position:"absolute", top:"-9999px", left:"-9999px", width:"1px", height:"1px" });
			document.body.appendChild(disposable);

			var availableStyles = disposable.currentStyle || document.defaultView.getComputedStyle(disposable, "");
			var resultProp = function(prefix){
				document.body.removeChild(disposable);
				return toChainCase(prop, prefix);
			};
			for(var i=0; i<candidates.length; i++){
				var chain = toChainCase(prop, candidates[i]);
				var camel = toCamelCase(prop, candidates[i]);
				var styleProp = toStyleProp(camel);

				if(availableStyles[chain] != null || availableStyles[camel] != null || availableStyles[styleProp] != null){
					return resultProp(candidates[i]);
				}
			}
			return !!noSupport ? noSupport : "";
		},

		/**
		*	指定した要素のブラウザが計算した現在のスタイルを取得します。
		*/
		currentStyle : function($element, prop, requireInt){
			var element = $element.get(0);
			var style = element.currentStyle || document.defaultView.getComputedStyle(element, '');
			return !prop ? style : !!requireInt ? parseInt(style[prop]) : style[prop];
		},

		/**
		*	指定された画像内の特定領域の平均色を返します。
		*/
		subrectColor : function(imageElement, originX, originY, width, height){
			var canvas = document.createElement("canvas");
			canvas.setAttribute("width", width);
			canvas.setAttribute("height", height);

			originX = Math.max(0, originX);
			originY = Math.max(0, originY);
			width = Math.max(0, width);
			height = Math.max(0, height);

			var con = canvas.getContext("2d");
			con.drawImage(imageElement, originX, originY, width, height, 0, 0, width, height);
			var rect = con.getImageData(0, 0, width, height);
			var dataLength = 0;
			var colors = { r : 0, g : 0, b : 0 };
			for(var i=0; i<rect.data.length; i++){
				switch(i%4){
					case 0: colors.r += rect.data[i]; break;
					case 1: colors.g += rect.data[i]; break;
					case 2: colors.b += rect.data[i]; break;
					case 3: dataLength++;
				}
			}
			dataLength = !dataLength ? 1 : dataLength;
			colors.r = Math.round(colors.r / dataLength);
			colors.g = Math.round(colors.g / dataLength);
			colors.b = Math.round(colors.b / dataLength);

			return colors;
		},

		averageColor : function(imageElement, defaultWidth, defaultHeight){
			var canvas = document.createElement("canvas");
			canvas.setAttribute("width", defaultWidth);
			canvas.setAttribute("height", defaultHeight);

			var con = canvas.getContext("2d");
			con.drawImage(imageElement, 0, 0, defaultWidth, defaultHeight, 0, 0, Math.round(20 * defaultWidth / defaultHeight), 20);
			var rect = con.getImageData(0, 0, Math.round(20 * defaultWidth / defaultHeight), 20);
			var dataLength = 0;
			var colors = { r : 0, g : 0, b : 0 };
			for(var i=0; i<rect.data.length; i++){
				switch(i%4){
					case 0: colors.r += rect.data[i]; break;
					case 1: colors.g += rect.data[i]; break;
					case 2: colors.b += rect.data[i]; break;
					case 3: dataLength++;
				}
			}
			dataLength = !dataLength ? 1 : dataLength;
			colors.r = Math.round(colors.r / dataLength);
			colors.g = Math.round(colors.g / dataLength);
			colors.b = Math.round(colors.b / dataLength);
			return colors;

		},

		/**
		*	RGBカラー表記をHSV表記に変換します。
		*	(明度の定義を変えた m:median を追加しています)
		*/
		rgb2hsv : function(r, g, b){
			var min = Math.min(r, g, b);
			var max = Math.max(r, g, b);

			var h = (function(){
				if(r == max){ return 60 * (g - b) / (max - min) + 0 }
				if(g == max){ return 60 * (b - r) / (max - min) + 120 }
				if(b == max){ return 60 * (r - g) / (max - min) + 240 }
				return 0;
			})();

			return {
				h : h < 0 ? (h + 360) : h,
				s : !max ? 0 : 100 * (max - min) / max,
				v : max,
				m : 100 * (r + g + b) / (255 * 3)
			}
		},

		/**
		* 動的に取得したスクロールバーの幅pxを格納します
		* (スクロールバーが表示されていない状態を考慮する場合は、都度、currentScrollbarWidth() を使用してください)
		*/
		scrollbarWidth : $(function(){
			var enough = 77;
			var $outer = $('<div>').css({ "box-sizing":"border-box", width:enough+"px", height:enough+"px", overflow:"scroll", position:"absolute", top:"0px", left:"0px" });
			var $inner = $('<div>').css({ "box-sizing":"border-box", width:"100%", height:"100%" });
			$(document.body).append($outer.append($inner));
			OH.scrollbarWidth = $outer.get(0).offsetWidth - $inner.get(0).offsetWidth;
			$outer.remove();
		}),

		/**
		* 現在のスクロールバーの幅pxを取得します
		*/
		currentScrollbarWidth : function(){
			return document.body.clientHeight > $(window).height() ? OH.scrollbarWidth : 0;
		},

		/**
		* 画面のスクロール可否を制御します。
		* flagにtrueを指定して実行すると、bodyのoverflowはhiddenさらにmarginを付加し、
		* 非表示となったスクロールバーによって表示コンテンツがブレないように調節されます。
		* flagにfalseを指定した場合は、そのスクロールロックを解除します。
		*/
		abortScroll : function(flag){
			if(flag){
				var currentMargin = parseInt($(document.body).css("margin-right"));
				$(document.documentElement).css("overflow", "hidden");
				$(document.body).css({ overflow : "hidden", "margin-right" : currentMargin + OH.currentScrollbarWidth() + "px" });
			}
			else{
				$(document.documentElement).css("overflow", "");
				$(document.body).css({ overflow : "", "margin-right" : "" });
			}
		},

		/**
		* ブラウザ情報を保持し、ページ読み込み時にはHTML要素に相応のclass名を付加します。
		*/
		browserInfo : (function(){
			var ua = {};
			ua.name = window.navigator.userAgent.toLowerCase();
      
      ua.isEdge = (ua.name.indexOf("edge") > -1);
			ua.isIE = (ua.name.indexOf("msie") >= 0 || ua.name.indexOf("trident") >= 0);
			ua.isiPhone = ua.name.indexOf("iphone") >= 0;
			ua.isiPod = ua.name.indexOf("ipod") >= 0;
			ua.isiPad = ua.name.indexOf("ipad") >= 0;
			ua.isiOS = (ua.isiPhone || ua.isiPod || ua.isiPad);
			ua.isAndroid = ua.name.indexOf("android") >= 0;
			ua.isTablet = (ua.isiPad || (ua.isAndroid && ua.name.indexOf("mobile") < 0));
			ua.isFirefox = ua.name.indexOf("firefox") >= 0;

			if(ua.isIE){
				ua.verArray = /(msie|rv:?)\s?([0-9]{1,})([\.0-9]{1,})/.exec(ua.name);
				if (ua.verArray) {
					ua.ver = parseInt(ua.verArray[2], 10);
				}
				document.documentElement.className += (!!document.documentElement.className ? " " : "") + "is-ie is-ie" + ua.ver;
			}
			if(ua.isiOS){
				ua.verArray = /(os)\s([0-9]{1,})([\_0-9]{1,})/.exec(ua.name);
				if (ua.verArray) {
				ua.ver = parseInt(ua.verArray[2], 10);
				}
				document.documentElement.className += (!!document.documentElement.className ? " " : "") + "is-ios is-ios" + ua.ver;
			}
			if(ua.isAndroid){
				ua.verArray = /(android)\s([0-9]{1,})([\.0-9]{1,})/.exec(ua.name);
				if (ua.verArray) {
				ua.ver = parseInt(ua.verArray[2], 10);
				}
				document.documentElement.className += (!!document.documentElement.className ? " " : "") + "is-android is-android" + ua.ver;
			}
			if(ua.isiPhone){
				document.documentElement.className += (!!document.documentElement.className ? " " : "") + "is-iphone";
			}
			if(ua.isiPod){
				document.documentElement.className += (!!document.documentElement.className ? " " : "") + "is-ipod";
			}
			if(ua.isiPad){
				document.documentElement.className += (!!document.documentElement.className ? " " : "") + "is-ipad";
			}
			if(ua.isFirefox){
				document.documentElement.className += (!!document.documentElement.className ? " " : "") + "is-firefox";
			}

			return ua;
		})(),
		/**
		*	数値で入り込むIDの値を文字列として扱わせるためのprefixです
		*	(vue.jsを扱う場合は、このprefixが必要になります)
		*/
		idPrefix : "_",

		/**
		*	タッチデバイスでのswipeを感知し、与えられた処理をcallbackします
		*/
		observeSwipe : function($element, callback){
			var threshold = 100;
			var maxDeg = 30;
			var start, dir, dist;
			var pos = function(event){
				return { x : event.originalEvent.touches[0].pageX, y : event.originalEvent.touches[0].pageY };
			};
			var tasks = {
				start : function(event){
					start = pos(event);
					dir = null;
					dist = { x :0, y : 0 };
				},
				move : function(event){
					var cpos = pos(event)
					dir = (start.x - cpos.x) > 0 ? 1 : -1;
					dist = {
						x : Math.abs(start.x - cpos.x),
						y : Math.abs(start.y - cpos.y)
					};
				},
				end : function(event){
					if(dist.x > threshold && (Math.atan(dist.y / dist.x) * 180 / Math.PI) < maxDeg){
						event.preventDefault();
						callback(dir);
					}
				}
			};

			$element.on("touchstart", tasks.start);
			$element.on("touchmove", tasks.move);
			$element.on("touchend", tasks.end);
		},
		
		/**
		*	observeFontloadで使用するテストケースの配列です。
		*	
		*/
		fontLoadCases : [
			{ name : "Brown", text : "OmotesandoHills" },
			{ name : "Noto Sans JP", text : "表参道ヒルズ" }
		],
		
		/**
		*	webfontのload完了を感知し、与えられた処理をcallbackします。
		*	lang="" か lang="ja" の場合のみ評価し、それ以外はcallbackを即実行します。
		*/
		observeFontload : function(fontCases, callback, forceFlag){
			var lang = document.documentElement.getAttribute("lang");
			if(!!lang && lang != "ja"){
				callback();
				return;
			}
			var length = fontCases.length;
			var fontState = new Object();
			var $group = $('<span>').css({
				position : "absolute",
				top : "-9999px",
				left : "-9999px"
			});
			$(document.body).append($group);
			
			for(var i=0; i<fontCases.length; i++){
				(function(fontCase){
					var result = {};
					var canvas = document.createElement("canvas");
					var measure = function(font){
						var con = canvas.getContext("2d");
						con.font = "normal 100px " + font;
						return con.measureText(fontCase.text);
					};
					$group.append($(canvas));
					
					var def = measure("fantasy");
					
					fontState[fontCase.name] = {
						measure : function(){
							return measure("'" + fontCase.name + "',fantasy");
						},
						defwidth : def.width
					};
				})(fontCases[i]);
			}
			var cnt = 0;
			var timer = window.setInterval(function(){
				var finallyFunc = function(timeoutFlag){
					window.clearInterval(timer);
					$group.remove();
					if((!timeoutFlag || !!forceFlag) && (typeof callback == "function")){
						callback();
					}
				};
				
				if(cnt++ > 77){
					finallyFunc(true);
					return;
				}
				for(var f in fontState){
					var current = fontState[f].measure();
					if(current.width != fontState[f].defwidth){
						delete fontState[f];
						length--;
					}
					
				}
				if(length == 0){
					finallyFunc(false);
				}
			}, 77);
		},
		
		/**
		*	カレンダー等に指定される休日を表す文字列の配列を取得します
		*/
		getHolidays : function(){
			if(!window.OH_HOLIDAYS || (typeof window.OH_HOLIDAYS != "function")){
				return [];
			}
			
			try{
				var result = [];
				var settings = window.OH_HOLIDAYS.toString();
				settings = settings.slice(settings.indexOf("/*") + "/*".length, settings.lastIndexOf("*/"));
				settings = settings.replace(/[\-]{2,}[\s\w]+[\-]{2,}/g, "").trim();
				settings = settings.split(/[\n\,]+/);
				
				for(var i=0; i<settings.length; i++){
					(function(index){
						var settingDate = settings[index];
						if(settingDate.indexOf("//") >= 0){
							settingDate = settingDate.slice(0, settingDate.indexOf("//"));
						}
						settingDate = settingDate.trim().replace(/[\/\.]/g, "");
						if(!!settingDate){
							result.push(settingDate);
						}
					})(i);
				}
				return result;
			}
			catch(e){
				return [];
			}
		},
		
		
		/**
		*	HTML内のscript要素で直接データを記述する場合の受け皿となる連想配列です
		*/
		listData : new Object(),
		
		
		/**
		*	storageのキーを管理します
		*/
		storageKeys : {
			refererHistory : "refererHistory",
			refineValues : "refineValues"
		}
	};
	
	window.requestAnimationFrame = (function(){
		return window.requestAnimationFrame ||
		window.webkitRequestAnimationFrame ||
		window.mozRequestAnimationFrame ||
		window.msRequestAnimationFrame ||
		window.oRequestAnimationFrame ||
		function(f) { return window.setTimeout(f, 1000 / 60); };
	})();
	
	window.cancelAnimationFrame = (function(){
		return window.cancelAnimationFrame ||
		 window.cancelRequestAnimationFrame ||
		 window.webkitCancelAnimationFrame ||
		 window.webkitCancelRequestAnimationFrame ||
		 window.mozCancelAnimationFrame ||
		 window.mozCancelRequestAnimationFrame ||
		 window.msCancelAnimationFrame ||
		 window.msCancelRequestAnimationFrame ||
		 window.oCancelAnimationFrame ||
		 window.oCancelRequestAnimationFrame ||
		 function(id) { window.clearTimeout(id); };
	})();
	
	
})(jQuery);
